import {useEffect} from 'react';

import log from '@/services/logger/log';

const useAppInstalled = () => {
    useEffect(() => {
        const handleAppInstalled = () => {
            log.info('Pwa App is installed');
        };

        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);
};

export default useAppInstalled;
